import axios from 'axios';

const getFijbLanguage = async () => {
    const API_URL = process.env.REACT_APP_URL;
    try {
        const response = await axios.get(API_URL + 'fijb/language' );
        if (!response.data) {
            throw new Error('Failed to fetch messages');
        }
        return response.data;
    } catch (error) {
        throw new Error('Failed to fetch messages: ' + (error as Error).message);
    }
};

export { getFijbLanguage };